import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles'
import { StylesProvider, jssPreset } from '@mui/styles'
import { create } from 'jss'
import rtl from 'jss-rtl'
import createTheme from '../styles/theme/theme'
import { isRtl, getCurrentLocale } from '../settings'

const defaultThemeDirection = isRtl ? 'rtl' : 'ltr'
const currentLocale = getCurrentLocale()

const ThemeContext = React.createContext()

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

function RTL(props) {
  return <StylesProvider jss={jss}>{props.children}</StylesProvider>
}

class ThemeProviderClass extends React.Component {
  constructor(...args) {
    super(...args)

    this.switchThemeDirection = (themeDirection) => {
      this.setState({ themeDirection }, () =>
        document.body.setAttribute('dir', themeDirection)
      )
    }

    document.body.setAttribute('dir', defaultThemeDirection)
    // pass everything in state to avoid creating object inside render method (like explained in the documentation)
    this.state = {
      themeDirection: defaultThemeDirection,
      switchThemeDirection: this.switchThemeDirection,
    }
  }

  render() {
    const { children } = this.props
    const { themeDirection } = this.state

    return (
      <ThemeContext.Provider value={this.state}>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider
            theme={createTheme({
              direction: themeDirection,
              locale: currentLocale,
            })}
          >
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
            {themeDirection === 'rtl' ? <RTL>{children}</RTL> : children}
          </MuiThemeProvider>
        </StyledEngineProvider>
      </ThemeContext.Provider>
    )
  }
}

export { ThemeProviderClass as ThemeProvider, ThemeContext }
